<template>
    <div>
        <main class="main-content mt-0">
            <section>
                <div class="page-header min-vh-100">
                    <div class="container">
                    <div class="row">
                        <div class="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
                        <div class="card card-plain">
                            <div class="pb-0 text-start">
                                <div class="row">
                                    <div class="col-12 text-center pb-4">
                                        <img src="@/assets/style/image/logoLogin.png" class="img-fluid" width="300px"/>
                                    </div>
                                </div>
                                
                                <h4 class="font-weight-bolder mt-3 text-center">Iniciar sesión</h4>
                                <p class="mb-0 pb-2 text-center">Ingrese su correo electrónico y contraseña para iniciar sesión</p>
                            </div>
                            <div class="card-body">
                                <form role="form">
                                    <div class="mb-3">
                                        <input @keyup.enter="keyEnter(0)" v-model="Usuario.Username" type="text" placeholder="Nombre del usuario" class="form-control form-control-lg" ref="user">
                                    </div>

                                    <div class="input-icons mb-3">
                                        
                                        <input @keyup.enter="keyEnter(1)" v-model="Usuario.Password" :type="type" class="form-control form-control-lg" placeholder="Contraseña" aria-label="Password" ref="pass">
                                        
                                        <button v-if="Usuario.Password !== ''" @click="ToggleShow" class="button btn-password" type="button" id="button-addon2">
                                            <i class="far icono-password" :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
                                        </button>
                                    </div>

                                  <!--  <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="rememberMe"> 
                                        <label class="form-check-label" for="rememberMe">Recordar acceso</label> 
                                    </div>-->
                                    <div class="text-center">
                                    <button :disabled="disabled" @click="GetLogin" type="button" class="btn btn-lg btn-primary btn-lg w-100 mt-4 mb-0">
                                        <i v-if="disabled" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                                        Iniciar sesión
                                    </button>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer text-center pt-0 px-lg-2 px-1">
                            <p class="mb-4 text-sm mx-auto">
                                ¿No tiene cuenta?
                                <a href="javascript:;" class="text-primary text-gradient font-weight-bold">Regístrate</a>
                            </p>
                            </div>
                        </div>
                        </div>
                        <div class="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
                        <div class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden" 
                        
                        :style=" cssProps">
                            <span class="mask bg-gradient-primary opacity-6"></span>
                        </div>
                        
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>

    export default {
        name:       'Login',
        props:      [""],
        components: {},
        data() {
            return {                
                type:            'password',
                showPassword:    false,
                password:        null,
                disabled:        false,
                errorvalidacion: [],
                Usuario: {
                    Username: '',
                    Password: '',
                },
                cssProps: {
                    backgroundImage: `url(${require('@/assets/style/image/bg_login.jpg')})`,
                    backgroundSize: 'cover'
                    
                },
                Icono: 'eye cursor-pointer',
            }
        },
        methods: {
            async GetLogin() {

                if (this.Usuario.Username !== '' && this.Usuario.Password !== '') {

                    this.disabled = true;

                    this.$http.post('login', this.Usuario).then((res) =>  {

                        this.disabled = false;

                        if (res.data.status) {
                            this.$store.dispatch('login',      res.data);
                            sessionStorage.setItem('RutaFile', res.data.RutaFile);
                            this.$router.push({name: "inicio", params: {}});
                        } else {
                            this.$toast.warning('Usuario o Contraseña Incorrectos');
                        }

                    })
                    .catch((err) => {
                        this.disabled = false;
                        this.$toast.error(err.response.data.message, 'Error');
                        this.$store.commit('auth_error');
                        this.$store.localStorage.removeItem('user_token');
                        this.$store.reject(err);
                    });
                } else {
                    this.$toast.error('Ingrese los campos faltantes', 'Campos Incompletos,');
                }

            },
            keyEnter(num) {

                if (this.Usuario.Username !== '' && this.Usuario.Password !== '') {
                    this.GetLogin();
                } else if (num === 0  && this.Usuario.Password === ''){
                    this.$refs.pass.focus();
                } else if (num === 1 && this.Usuario.Username === ''){
                    this.$refs.user.focus();
                }
            },
            ToggleShow() {

                if (this.showPassword = !this.showPassword) {                    
                    this.type = 'text';
                    this.Icono = 'eyeClose cursor-pointer';
                } else {
                    this.type = 'password';
                    this.Icono = 'eye cursor-pointer';
                }
                
            },
        },
        created() {
            // SI EXISTE SESSIÓN REGRESAMOS A LA VISTA PRINCIPAL (INICIO)
            var datos = JSON.parse( sessionStorage.getItem('user'));

            if(datos != null){
                this.$router.push({name: "inicio", params: {}});
            }

        },
        mounted() {
            this.$refs.user.focus();
        },
    }

</script>
